import { delayTaskParameters } from "../../../shared/consts/table";
import { IDelayQuestions } from "../../../shared/types/questions";
import { headerAuthorization } from "../../../shared/helpers/localstorage-helper";
import { BASE_URL } from '../../../shared/consts/variables';

export interface IPlanUsage {
    companyName: string;
    planName: string;
    usedThisMonth: number;
    monthlyLimit: number;
    remaining: number | 'ilimitado';
    resetsAt: string;
}

export interface ICreateAnswerResponse extends IDelayQuestions {
    id?: number;
    createdAt?: string;
    updatedAt?: string;
    planUsage: IPlanUsage;
}

export interface IGetAnswersResponse {
    data: IDelayQuestions[];
    total: number;
    filters: {
        companyId: string;  // ✅ Mudado de clientId
        startDate: string | null;
        endDate: string | null;
    };
    period: {
        start: string | null;
        end: string | null;
    };
}

export const fetchSearchResults = async () => {
    return delayTaskParameters;    
}

export const postSearchResults = async (resultObject: IDelayQuestions): Promise<ICreateAnswerResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/questions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headerAuthorization()
        },
        body: JSON.stringify(resultObject),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao criar resposta');
    }

    return response.json();
}

export const getSearchResults = async (query: URLSearchParams): Promise<IGetAnswersResponse> => {
    const response = await fetch(`${BASE_URL}/dd-curto/questions?${query}`, {
        headers: {
            ...headerAuthorization()
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar respostas');
    }

    return response.json();
}